import { capitalize, toDate } from "@flaminem/utils";
import { FC } from "react";

import ScenarioRulesTable from "src/components/scenario/ScenarioRulesTable/ScenarioRulesTable.tsx";
import { useFormatDate, useT } from "src/internationalization";
import {
  isDefinedScenarioRule,
  ScenarioVersion,
  ScenarioVersionWithRules,
} from "src/types/scenario.ts";

type ActiveScenarioVersionTabProps = {
  activeScenarioVersion: ScenarioVersion & ScenarioVersionWithRules;
};

export const ActiveScenarioVersionTab: FC<ActiveScenarioVersionTabProps> = ({
  activeScenarioVersion,
}) => {
  const t = useT();
  const formatDate = useFormatDate();

  return (
    <div className="flex flex-col gap-5 pt-5 h-full">
      <div className="px-5">
        <h4 className="cds--data-table-header__title">{t("scenario.tab.active.title")}</h4>
        <p className="cds--data-table-header__description">
          {t("scenario.tab.active.description")}
        </p>
      </div>

      <div className="flex justify-between px-5">
        <div>
          <p>
            <span className="text-label02 text-textSecondary leading-label02 tracking-label02 font-label02">
              {t("general.form.name.label")}:{" "}
            </span>
            {activeScenarioVersion.name}
          </p>
          <p>
            <span className="text-label02 text-textSecondary leading-label02 tracking-label02 font-label02">
              {t("scenario.tab.label.threshold")}:{" "}
            </span>
            {activeScenarioVersion.threshold}
          </p>
          <p>
            <span className="text-label02 text-textSecondary leading-label02 tracking-label02 font-label02">
              {t("scenario.tab.label.date")}:{" "}
            </span>
            {formatDate(toDate(activeScenarioVersion.adminStatus.creation), {
              dateStyle: "medium",
            })}
          </p>
          {activeScenarioVersion.description && (
            <div className="line-clamp-3 text-body02 leading-body02 tracking-body02 font-body02">
              <span className="text-label02 text-textSecondary leading-label02 tracking-label02 font-label02">
                {t("general.table.description.column.title")}:{" "}
              </span>
              {capitalize(activeScenarioVersion.description)}
            </div>
          )}
        </div>
      </div>
      <ScenarioRulesTable
        rules={activeScenarioVersion.rules.filter(isDefinedScenarioRule).map((details) => ({
          ...details.rule,
          score: details.score,
        }))}
      />
    </div>
  );
};
